
import {Options, Vue} from "vue-class-component";
import {isDefined} from "@/utils";
import {Speech} from "@/entities/Speech";
import LazyLoadContainer from "@/components/LazyLoadComponent.vue";

@Options({
  components: {LazyLoadContainer},
  props: {
    onClose: {
      required: false,
      type: Function,
    },
    openExhibitorDialog: {
      required: true,
      type: Function,
    },
    getLangForSpeechById: {
      required: true,
      type: Function,
    },
    getIconColorCSS: {
      required: true,
      type: Function,
    },
    openSpeakerDetailDialog: {
      required: true,
      type: Function,
    },
    openStandDialog: {
      required: true,
      type: Function,
    },
    isFavorite: {
      required: true,
      type: Function,
    },
    toggleFavorite: {
      required: true,
      type: Function,
    },
    getBorderColorCSS: {
      required: true,
      type: Function,
    },
    getSpeakerById: {
      required: true,
      type: Function,
    },
    enableFavorites: {
      required: true,
      type: Boolean,
    },
    roles: {
      required: true,
    },
  },
})
export default class SpeechDetailDialog extends Vue {
  public isOpen: boolean = false;
  public onClose: Function;
  public speeches: Speech[] = [];

  constructor(props) {
    super(props);
  }

  public openDialog(speeches: Speech[]): void {
    this.isOpen = true;
    this.speeches = speeches;
  }

  public closeDialog(event: Event): void {
    event.stopImmediatePropagation();
    if (isDefined(this.onClose)) {
      this.onClose();
    }
    this.isOpen = false;
  }
}
